// Generated by packages/lesson-schema/scripts/world-assets.mjs from apps/headset/worlds/manifest.json. Do not edit.
export const PLATFORM_SKIES = {
    hospital_room_2: {
        width: 1024,
        height: 512,
        bytes: 1609763,
    },
    kloofendal_48d_partly_cloudy_puresky: {
        width: 2048,
        height: 1024,
        bytes: 5451493,
    },
    overcast_soil_puresky: {
        width: 2048,
        height: 1024,
        bytes: 4568000,
    },
};
export const PLATFORM_TEXTURES = {
    aerial_grass_rock: {
        diff: {
            width: 1024,
            height: 1024,
            bytes: 666655,
        },
    },
    aerial_rocks_02: {
        diff: {
            width: 1024,
            height: 1024,
            bytes: 785923,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 1177932,
        },
    },
    asphalt_02: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 296770,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 731707,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 1240122,
        },
    },
    bunsen_burner: {
        arm: {
            width: 512,
            height: 512,
            bytes: 64000,
        },
        diff: {
            width: 512,
            height: 512,
            bytes: 42343,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 32422,
        },
    },
    chemistry_set: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 950518,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 553332,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 440776,
        },
    },
    coast_sand_01: {
        diff: {
            width: 1024,
            height: 1024,
            bytes: 960614,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 1146826,
        },
    },
    crystalline_iceplant: {
        diff: {
            width: 512,
            height: 512,
            bytes: 415420,
        },
    },
    dead_quiver_trunk: {
        diff: {
            width: 512,
            height: 512,
            bytes: 61567,
        },
    },
    fern_02: {
        diff: {
            width: 512,
            height: 512,
            bytes: 380812,
        },
    },
    floor_klinkers_01: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 419938,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 950011,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 884658,
        },
    },
    floor_tiles_06: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 54871,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 356257,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 121299,
        },
    },
    forest_leaves_02: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 313980,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 437891,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 577163,
        },
    },
    gravel_ground_01: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 151288,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 954257,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 1314248,
        },
    },
    industrial_microscope: {
        arm: {
            width: 512,
            height: 512,
            bytes: 72410,
        },
        diff: {
            width: 512,
            height: 512,
            bytes: 51349,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 57198,
        },
    },
    marble_01: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 54740,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 305029,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 110230,
        },
    },
    marble_bust_01: {
        diff: {
            width: 512,
            height: 512,
            bytes: 44803,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 39472,
        },
    },
    metal_stool_02: {
        arm: {
            width: 512,
            height: 512,
            bytes: 65892,
        },
        diff: {
            width: 512,
            height: 512,
            bytes: 53805,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 31550,
        },
    },
    moon_rock_02: {
        arm: {
            width: 512,
            height: 512,
            bytes: 17357,
        },
        diff: {
            width: 512,
            height: 512,
            bytes: 16838,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 52513,
        },
    },
    potted_plant_04: {
        arm: {
            width: 512,
            height: 512,
            bytes: 40718,
        },
        diff: {
            width: 512,
            height: 512,
            bytes: 52114,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 72069,
        },
    },
    quiver_tree_02: {
        diff: {
            width: 512,
            height: 512,
            bytes: 61909,
        },
    },
    red_brick_03: {
        diff: {
            width: 1024,
            height: 1024,
            bytes: 694500,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 955430,
        },
    },
    rock_07: {
        arm: {
            width: 512,
            height: 512,
            bytes: 24949,
        },
        diff: {
            width: 512,
            height: 512,
            bytes: 49637,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 59192,
        },
    },
    shrub_02: {
        diff: {
            width: 512,
            height: 512,
            bytes: 440954,
        },
    },
    shrub_03: {
        diff: {
            width: 512,
            height: 512,
            bytes: 533547,
        },
    },
    steel_frame_shelves_01: {
        arm: {
            width: 1024,
            height: 1024,
            bytes: 655560,
        },
        diff: {
            width: 1024,
            height: 1024,
            bytes: 477882,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 318836,
        },
    },
    wall_clock: {
        arm: {
            width: 512,
            height: 512,
            bytes: 41059,
        },
        diff: {
            width: 512,
            height: 512,
            bytes: 32979,
        },
        nor_gl: {
            width: 512,
            height: 512,
            bytes: 23935,
        },
    },
    white_plaster_02: {
        diff: {
            width: 1024,
            height: 1024,
            bytes: 527219,
        },
        nor_gl: {
            width: 1024,
            height: 1024,
            bytes: 652310,
        },
    },
};
export const PLATFORM_SOUNDSCAPES = {
    beach: {
        bytes: 101213,
    },
    forest: {
        bytes: 252621,
    },
    meadow: {
        bytes: 243587,
    },
    'modern-street': {
        bytes: 237322,
    },
    'museum-hall': {
        bytes: 252257,
    },
    polder: {
        bytes: 417521,
    },
    'science-lab': {
        bytes: 0,
    },
    'sea-floor': {
        bytes: 0,
    },
    'town-square': {
        bytes: 425554,
    },
    villa: {
        bytes: 101213,
    },
    'volcanic-island': {
        bytes: 101213,
    },
};
export const PLATFORM_MODELS = {
    bunsen_burner: {
        triangles: 8434,
        materials: 1,
        bytes: 410298,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.0694, 0, -0.0694],
            max: [0.0694, 0.1731, 0.0694],
        },
        variants: [],
    },
    chemistry_set: {
        triangles: 41958,
        materials: 2,
        bytes: 3173294,
        textures: [
            {
                width: 1024,
                height: 1024,
            },
            {
                width: 1024,
                height: 1024,
            },
            {
                width: 1024,
                height: 1024,
            },
        ],
        bounds: {
            min: [-0.5248, -0.009, -0.2289],
            max: [0.5536, 0.42, 0.125],
        },
        variants: [],
    },
    crystalline_iceplant: {
        triangles: 1993,
        materials: 1,
        bytes: 485082,
        textures: [
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.8011, -0.0035, -0.4324],
            max: [0.8924, 0.0787, 0.3055],
        },
        variants: [
            {
                name: 'crystalline_iceplant_a_LOD0',
                triangles: 468,
                size: [0.276, 0.081, 0.316],
            },
            {
                name: 'crystalline_iceplant_b_LOD0',
                triangles: 392,
                size: [0.28, 0.065, 0.306],
            },
            {
                name: 'crystalline_iceplant_c_LOD0',
                triangles: 351,
                size: [0.267, 0.061, 0.227],
            },
            {
                name: 'crystalline_iceplant_d_LOD0',
                triangles: 288,
                size: [0.144, 0.038, 0.183],
            },
            {
                name: 'crystalline_iceplant_e_LOD0',
                triangles: 207,
                size: [0.153, 0.029, 0.112],
            },
            {
                name: 'crystalline_iceplant_f_LOD0',
                triangles: 129,
                size: [0.111, 0.027, 0.088],
            },
            {
                name: 'crystalline_iceplant_g_LOD0',
                triangles: 90,
                size: [0.108, 0.029, 0.092],
            },
            {
                name: 'crystalline_iceplant_h_LOD0',
                triangles: 68,
                size: [0.054, 0.016, 0.059],
            },
        ],
    },
    dead_quiver_trunk: {
        triangles: 1994,
        materials: 1,
        bytes: 115495,
        textures: [
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.1705, 0.0118, -0.1311],
            max: [0.1348, 2.0052, 0.137],
        },
        variants: [
            {
                name: 'dead_quiver_trunk_LOD0',
                triangles: 1994,
                size: [0.305, 1.993, 0.268],
            },
        ],
    },
    fern_02: {
        triangles: 1995,
        materials: 1,
        bytes: 449811,
        textures: [
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.5281, -0.0305, -0.4219],
            max: [1.4429, 0.3972, 1.3022],
        },
        variants: [
            {
                name: 'fern_02_b',
                triangles: 765,
                size: [0.989, 0.428, 0.894],
            },
            {
                name: 'fern_02_c',
                triangles: 720,
                size: [0.873, 0.349, 0.75],
            },
            {
                name: 'fern_02_a',
                triangles: 250,
                size: [0.552, 0.287, 0.614],
            },
            {
                name: 'fern_02_d',
                triangles: 260,
                size: [0.573, 0.213, 0.593],
            },
        ],
    },
    industrial_microscope: {
        triangles: 16598,
        materials: 1,
        bytes: 786074,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.0938, -0.0016, -0.3315],
            max: [0.1208, 0.4601, 0.1666],
        },
        variants: [],
    },
    marble_bust_01: {
        triangles: 5000,
        materials: 1,
        bytes: 267032,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.1229, 0.0002, -0.1446],
            max: [0.1489, 0.515, 0.1551],
        },
        variants: [
            {
                name: 'marble_bust_01',
                triangles: 5000,
                size: [0.272, 0.515, 0.3],
            },
        ],
    },
    metal_stool_02: {
        triangles: 6532,
        materials: 1,
        bytes: 336031,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.224, 0, -0.2352],
            max: [0.2241, 0.4581, 0.2379],
        },
        variants: [],
    },
    moon_rock_02: {
        triangles: 3304,
        materials: 1,
        bytes: 167482,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.1247, -0.0061, -0.1251],
            max: [0.1218, 0.1959, 0.1262],
        },
        variants: [],
    },
    potted_plant_04: {
        triangles: 8929,
        materials: 1,
        bytes: 411049,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.0839, 0.0004, -0.0839],
            max: [0.0839, 0.2678, 0.1008],
        },
        variants: [],
    },
    quiver_tree_02: {
        triangles: 3999,
        materials: 1,
        bytes: 199409,
        textures: [
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.4818, -0.0463, -0.4268],
            max: [0.381, 1.4185, 0.4484],
        },
        variants: [
            {
                name: 'quiver_tree_02',
                triangles: 3999,
                size: [0.863, 1.465, 0.875],
            },
        ],
    },
    rock_07: {
        triangles: 14844,
        materials: 1,
        bytes: 604679,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.0876, -0.0019, -0.178],
            max: [0.0813, 0.1418, 0.1423],
        },
        variants: [],
    },
    shrub_02: {
        triangles: 3854,
        materials: 1,
        bytes: 602944,
        textures: [
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-2.3021, -0.6064, -1.1912],
            max: [4.2638, 1.9413, 1.3448],
        },
        variants: [
            {
                name: 'shrub_02_a',
                triangles: 1064,
                size: [1.626, 2.151, 1.83],
            },
            {
                name: 'shrub_02_b',
                triangles: 746,
                size: [2.06, 1.949, 1.816],
            },
            {
                name: 'shrub_02_c',
                triangles: 1314,
                size: [2.483, 2.381, 2.536],
            },
            {
                name: 'shrub_02_d',
                triangles: 730,
                size: [1.607, 1.938, 1.809],
            },
        ],
    },
    shrub_03: {
        triangles: 1994,
        materials: 1,
        bytes: 616380,
        textures: [
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.0735, -0.0018, -0.0727],
            max: [1.2931, 0.401, 0.0785],
        },
        variants: [
            {
                name: 'shrub_03_a',
                triangles: 573,
                size: [0.201, 0.403, 0.151],
            },
            {
                name: 'shrub_03_b',
                triangles: 513,
                size: [0.184, 0.353, 0.123],
            },
            {
                name: 'shrub_03_c',
                triangles: 432,
                size: [0.096, 0.304, 0.113],
            },
            {
                name: 'shrub_03_d',
                triangles: 476,
                size: [0.112, 0.256, 0.089],
            },
        ],
    },
    steel_frame_shelves_01: {
        triangles: 4348,
        materials: 1,
        bytes: 1596422,
        textures: [
            {
                width: 1024,
                height: 1024,
            },
            {
                width: 1024,
                height: 1024,
            },
            {
                width: 1024,
                height: 1024,
            },
        ],
        bounds: {
            min: [-5.4869, -0.0107, -2.5106],
            max: [5.4873, 21.3943, 2.5106],
        },
        variants: [],
    },
    wall_clock: {
        triangles: 3658,
        materials: 2,
        bytes: 261633,
        textures: [
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
            {
                width: 512,
                height: 512,
            },
        ],
        bounds: {
            min: [-0.1602, -0.1602, 0],
            max: [0.1602, 0.1602, 0.0472],
        },
        variants: [],
    },
};
//# sourceMappingURL=assets.generated.js.map